import { render } from "./index.vue?vue&type=template&id=0d152db8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0d152db8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d152db8"

export default script